<template>
  <div class="app-container">
    <div class="page-title" style="display:flex;align-items:center;gap:8px;justify-content:space-between;">
      <div style="display:flex;align-items:center;gap:8px">
        <h2>{{ $t('scoop.scoops') }}</h2>
        <h2>🏢</h2>
      </div>
      <el-button icon="el-icon-close" @click="goBack">{{ $t('general.cancel') }}</el-button>
    </div>

    <el-breadcrumb separator-class="el-icon-arrow-right" style="margin-bottom:15px">
      <el-breadcrumb-item style="cursor:pointer" @click.native="$router.push('/bureau/scoops')">{{ $t('scoop.scoops') }}</el-breadcrumb-item>
      <el-breadcrumb-item>{{ scoop ? scoop.nom : '...' }}</el-breadcrumb-item>
    </el-breadcrumb>

    <el-row :gutter="20">
      <el-col :span="7">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span style="font-weight:bold">{{ $t('scoop.superviseur') }}</span>
            <el-button v-if="checkPermission(['modifier scoop'])" style="float: right; padding: 3px 0" type="text" @click="openSuperviseurDialog">{{ $t('general.edit') }}</el-button>
          </div>
          <el-table v-loading="loading" :data="superviseurInfos" :show-header="false" size="small">
            <el-table-column>
              <template slot-scope="scope">
                <strong>{{ scope.row.libelle }}</strong>
              </template>
            </el-table-column>
            <el-table-column>
              <template slot-scope="scope">
                <span>{{ scope.row.valeur }}</span>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </el-col>

      <el-col :span="17">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span style="font-weight:bold">{{ $t('general.otherInfos') }}</span>
            <el-button v-if="checkPermission(['modifier scoop'])" style="float: right; padding: 3px 0" type="text" icon="el-icon-edit" @click="openEditDialog">{{ $t('general.edit') }}</el-button>
          </div>
          <el-tabs v-model="activeTab" tab-position="top">
            <el-tab-pane name="org" :label="$t('scoop.scoops')">
              <el-table v-loading="loading" :data="organisationInfos" :show-header="false" size="small">
                <el-table-column>
                  <template slot-scope="scope">
                    <strong>{{ scope.row.libelle }}</strong>
                  </template>
                </el-table-column>
                <el-table-column>
                  <template slot-scope="scope">
                    <span>{{ scope.row.valeur }}</span>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane name="up" :label="$t('scoop.unitesProduction')">
              <div style="margin-bottom:10px;text-align:right">
                <el-button
                  v-if="checkPermission(['modifier scoop'])"
                  type="primary"
                  size="small"
                  icon="el-icon-plus"
                  @click="openAffectationDialog"
                >
                  {{ $t('scoop.unitesProduction') }}
                </el-button>
              </div>
              <el-table v-loading="loadingUp" :data="unitesProduction" border fit highlight-current-row style="width: 100%">
                <el-table-column align="center" label="Code" min-width="120px">
                  <template slot-scope="scope">
                    <span>{{ scope.row.code }}</span>
                  </template>
                </el-table-column>
                <el-table-column align="center" :label="$t('general.nom')" min-width="180px">
                  <template slot-scope="scope">
                    <span>{{ scope.row.nom }}</span>
                  </template>
                </el-table-column>
                <el-table-column align="center" :label="$t('general.description')" min-width="240px">
                  <template slot-scope="scope">
                    <span>{{ scope.row.description }}</span>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="Structure" min-width="160px">
                  <template slot-scope="scope">
                    <span>{{ scope.row.structure ? scope.row.structure.nom : '' }}</span>
                  </template>
                </el-table-column>
                <el-table-column v-if="checkPermission(['modifier scoop'])" align="center" :label="$t('general.actions')" width="160px">
                  <template slot-scope="scope">
                    <el-button type="info" size="small" icon="el-icon-view" @click="goToUP(scope.row.id)" />
                    <el-button type="danger" size="small" icon="el-icon-delete" @click="removeUP(scope.row.id)" />
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
          </el-tabs>
        </el-card>
      </el-col>
    </el-row>

    <!-- Dialog edit scoop -->
    <el-dialog :title="$t('scoop.edit')" :visible.sync="dialogEdit" width="40%">
      <el-form ref="editForm" :model="form" :rules="rules" label-position="left" label-width="140px">
        <el-form-item :label="$t('scoop.code')" prop="code">
          <el-input v-model="form.code" maxlength="10" show-word-limit />
        </el-form-item>
        <el-form-item :label="$t('scoop.nom')" prop="nom">
          <el-input v-model="form.nom" maxlength="100" show-word-limit />
        </el-form-item>
        <el-form-item :label="$t('scoop.description')" prop="description">
          <el-input v-model="form.description" type="textarea" :rows="3" />
        </el-form-item>
        <el-form-item :label="$t('scoop.superviseur')" prop="responsable_id">
          <el-select
            v-model="form.responsable_id"
            filterable
            remote
            reserve-keyword
            :remote-method="remoteSuperviseurSearch"
            :loading="loadingSuperviseurs"
            style="width:100%"
            placeholder="Superviseur"
          >
            <el-option
              v-for="sup in superviseurs"
              :key="sup.id"
              :label="sup.nom + ' ' + sup.prenom"
              :value="sup.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item v-if="checkPermission(['activer scoop'])" :label="$t('general.status')" prop="is_active">
          <el-switch v-model="form.is_active" />
        </el-form-item>
        <el-form-item v-if="checkRole(['admin'])" :label="$t('general.visible')" prop="is_visible">
          <el-switch v-model="form.is_visible" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button plain type="danger" @click="dialogEdit=false">{{ $t('general.cancel') }}</el-button>
        <el-button type="primary" :loading="saving" @click="submitEdit">{{ saving ? $t('general.saving') : $t('general.save') }}</el-button>
      </span>
    </el-dialog>

    <!-- Dialog superviseur -->
    <el-dialog :title="$t('scoop.superviseur')" :visible.sync="dialogSuperviseur" width="30%">
      <el-select
        v-model="form.responsable_id"
        filterable
        remote
        reserve-keyword
        :remote-method="remoteSuperviseurSearch"
        :loading="loadingSuperviseurs"
        style="width:100%"
        placeholder="Superviseur"
      >
        <el-option
          v-for="sup in superviseurs"
          :key="sup.id"
          :label="sup.nom + ' ' + sup.prenom"
          :value="sup.id"
        />
      </el-select>
      <span slot="footer" class="dialog-footer">
        <el-button plain type="danger" @click="dialogSuperviseur=false">{{ $t('general.cancel') }}</el-button>
        <el-button type="primary" :loading="saving" @click="submitSuperviseur">{{ saving ? $t('general.saving') : $t('general.save') }}</el-button>
      </span>
    </el-dialog>

    <!-- Dialog affectation UP -->
    <el-dialog :title="$t('scoop.unitesProduction')" :visible.sync="dialogUP" width="40%">
      <el-select
        v-model="selectedUP"
        multiple
        filterable
        remote
        :remote-method="remoteUPSearch"
        :loading="loadingUpSelect"
        style="width:100%"
        placeholder="UP"
      >
        <el-option
          v-for="up in upOptions"
          :key="up.id"
          :label="up.nom"
          :value="up.id"
        />
      </el-select>
      <span slot="footer" class="dialog-footer">
        <el-button plain type="danger" @click="dialogUP=false">{{ $t('general.cancel') }}</el-button>
        <el-button type="primary" :loading="saving" @click="submitUP">{{ saving ? $t('general.saving') : $t('general.save') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import waves from '@/directive/waves';
import permission from '@/directive/permission';
import role from '@/directive/role';
import checkPermission from '@/utils/permission';
import checkRole from '@/utils/role';
import scoopApi from '@/api/scoop';
import Resource from '@/api/resource';

const uniteResource = new Resource('unite_productions');
const controleurResource = new Resource('controleurs');

export default {
  name: 'ScoopUniquePage',
  directives: { waves, permission, role },
  data() {
    return {
      scoop: null,
      loading: true,
      loadingUp: false,
      activeTab: 'org',
      unitesProduction: [],
      dialogEdit: false,
      dialogSuperviseur: false,
      dialogUP: false,
      saving: false,
      form: {
        code: '',
        nom: '',
        description: '',
        responsable_id: null,
        is_active: true,
        is_visible: true,
      },
      rules: {
        nom: [{ required: true, message: this.$t('scoop.NomRequired'), trigger: 'blur' }],
      },
      superviseurs: [],
      loadingSuperviseurs: false,
      upOptions: [],
      loadingUpSelect: false,
      selectedUP: [],
    };
  },
  computed: {
    organisationInfos() {
      if (!this.scoop) {
        return [];
      }
      return [
        { libelle: this.$t('scoop.code'), valeur: this.scoop.code || '-' },
        { libelle: this.$t('scoop.nom'), valeur: this.scoop.nom || '-' },
        { libelle: this.$t('scoop.description'), valeur: this.scoop.description || '-' },
        { libelle: this.$t('general.status'), valeur: this.scoop.is_active ? this.$t('general.M_actif') : this.$t('general.M_desactives') },
        { libelle: this.$t('general.visible'), valeur: this.scoop.is_visible ? this.$t('general.visible') : this.$t('general.nonVisibles') },
        { libelle: 'Créé par', valeur: this.scoop.created_by || '-' },
      ];
    },
    superviseurInfos() {
      const resp = this.scoop ? (this.scoop.responsable || this.scoop.controleur_responsable) : null;
      if (!resp) {
        return [{ libelle: this.$t('scoop.superviseur'), valeur: '-' }];
      }
      return [
        { libelle: this.$t('scoop.superviseur'), valeur: `${resp.nom || ''} ${resp.prenom || ''}` },
        { libelle: 'Email', valeur: resp.email || '-' },
        { libelle: 'Téléphone', valeur: resp.telephone || resp.numero || '-' },
      ];
    },
  },
  watch: {
    '$route.params.id': {
      immediate: true,
      handler() {
        this.load();
      },
    },
  },
  methods: {
    checkPermission,
    checkRole,
    async load() {
      this.loading = true;
      const id = this.$route.params.id;
      try {
        const { data } = await scoopApi.get(id);
        this.scoop = data;
        this.form = {
          code: data.code || '',
          nom: data.nom || '',
          description: data.description || '',
          responsable_id: data.responsable_id || (data.responsable ? data.responsable.id : null),
          is_active: !!data.is_active,
          is_visible: !!data.is_visible,
        };
        this.fetchUnites();
      } finally {
        this.loading = false;
      }
    },
    async fetchUnites() {
      this.loadingUp = true;
      try {
        const { data } = await scoopApi.getUnitesProduction(this.$route.params.id);
        this.unitesProduction = data || [];
      } finally {
        this.loadingUp = false;
      }
    },
    openEditDialog() {
      this.dialogEdit = true;
      this.$nextTick(() => this.$refs.editForm && this.$refs.editForm.clearValidate());
    },
    openSuperviseurDialog() {
      this.dialogSuperviseur = true;
      this.remoteSuperviseurSearch('');
    },
    openAffectationDialog() {
      this.dialogUP = true;
      this.remoteUPSearch('');
      this.selectedUP = this.unitesProduction.map(up => up.id);
    },
    async submitEdit() {
      this.$refs.editForm.validate(async(valid) => {
        if (!valid) {
          return;
        }
        this.saving = true;
        try {
          await scoopApi.update(this.$route.params.id, this.form);
          this.$message({ type: 'success', message: this.$t('scoop.isupdatedSuccessfully') });
          this.dialogEdit = false;
          this.load();
        } finally {
          this.saving = false;
        }
      });
    },
    async submitSuperviseur() {
      if (!this.form.responsable_id) {
        this.$message({ type: 'warning', message: this.$t('scoop.NomRequired') });
        return;
      }
      this.saving = true;
      try {
        await scoopApi.update(this.$route.params.id, {
          ...this.form,
          responsable_id: this.form.responsable_id,
        });
        this.$message({ type: 'success', message: this.$t('scoop.isupdatedSuccessfully') });
        this.dialogSuperviseur = false;
        this.load();
      } finally {
        this.saving = false;
      }
    },
    async submitUP() {
      if (!this.selectedUP.length) {
        this.$message({ type: 'warning', message: this.$t('general.formInvalid') });
        return;
      }
      this.saving = true;
      try {
        await scoopApi.affecterUnitesProduction(this.$route.params.id, this.selectedUP);
        this.$message({ type: 'success', message: this.$t('general.statusUpdated') });
        this.dialogUP = false;
        this.fetchUnites();
      } finally {
        this.saving = false;
      }
    },
    async removeUP(id) {
      const remaining = this.unitesProduction.filter(up => up.id !== id).map(up => up.id);
      this.selectedUP = remaining;
      await this.submitUP();
    },
    goToUP(id) {
      this.$router.push({ path: '/uniteProduction/' + id });
    },
    goBack() {
      this.$router.push('/bureau/scoops');
    },
    async remoteSuperviseurSearch(keyword) {
      this.loadingSuperviseurs = true;
      try {
        const params = { keyword, grade_id: 2 };
        const { data } = await controleurResource.list(params);
        this.superviseurs = data || [];
      } finally {
        this.loadingSuperviseurs = false;
      }
    },
    async remoteUPSearch(keyword) {
      this.loadingUpSelect = true;
      try {
        const params = { keyword, limit: 200 };
        const { data: allUP } = await uniteResource.list(params);
        const { data: allScoops } = await scoopApi.list({ limit: 1000 });
        // Collecter tous les IDs d'UP déjà affectées à une scoop
        const affectedUPIds = new Set();
        if (allScoops && Array.isArray(allScoops)) {
          allScoops.forEach(scoop => {
            if (scoop.unites_production && Array.isArray(scoop.unites_production)) {
              scoop.unites_production.forEach(up => {
                affectedUPIds.add(up.id);
              });
            }
            // Gérer aussi le cas où les UP sont chargées via une relation
            if (scoop.unites_production_count && scoop.unites_production_count > 0) {
              // Si on a seulement le count, on devra vérifier différemment
            }
          });
        }

        // Exclure les UP déjà affectées, mais inclure celles de la scoop courante
        const currentScoopUPIds = this.unitesProduction.map(up => up.id);
        this.upOptions = (allUP || []).filter(up => {
          // Inclure si pas affectée OU si c'est déjà dans la scoop courante
          return !affectedUPIds.has(up.id) || currentScoopUPIds.includes(up.id);
        });
      } finally {
        this.loadingUpSelect = false;
      }
    },
  },
};
</script>

<style scoped>
.page-title {
  margin-bottom: 10px;
}
</style>

